import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const BrickmouldWidth = ({ value, onChange, label = 'Brickmould Width'}) => {
    const [selectedBrickmouldWidth, setSelectedBrickmouldWidth] = useState(value || "");
     const [BrickmouldWidthError, setBrickmouldWidthError] = useState("");


    useEffect(() => {
      }, []); // Trigger effect whenever doorSizeValue changes

    const handleBrickmouldWidthChange = (e) => {
        //setSelectedBrickmouldWidth(e.target.value);
        validateBrickmouldWidth(e.target.value);
        onChange(e.target.value);
    };
    const validateBrickmouldWidth = (value) => {
        const numericValue = value; //value.replace(/\D/g, ""); // Allow only numbers
        setSelectedBrickmouldWidth(numericValue);
        const element = document.getElementById('FrameWidth');
        let maxValue = 999;
        if (element) {
            maxValue = element.value;
        }
  
        if (numericValue && (numericValue < maxValue)) {
            setBrickmouldWidthError('Brickmould Width must be greater than or equal to ' + maxValue);
        } else {
            setBrickmouldWidthError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="BrickmouldWidth">{label}</label>
            <input style={{ display: "none" }}
                id="BrickmouldWidth"
                value={selectedBrickmouldWidth}
                onChange={handleBrickmouldWidthChange}
            >
            </input>
            {BrickmouldWidthError && <p className="error">{BrickmouldWidthError}</p>}
        </div>
    );
};

export default BrickmouldWidth;
